import {
  BarChart3,
  Bell,
  CreditCard,
  FileCode,
  Globe,
  Key,
  LayoutDashboard,
  Mail,
  Megaphone,
  Plug,
  Server,
  Settings,
  ShieldOff,
  Users,
  Webhook,
} from 'lucide-react'

export const ICON_MAP = {
  LayoutDashboard,
  Mail,
  Globe,
  BarChart3,
  Key,
  Webhook,
  ShieldOff,
  Settings,
  FileCode,
  Server,
  Bell,
  Users,
  Megaphone,
  CreditCard,
  Plug,
} as const

export interface NavItem {
  path: string
  label: string
  icon: keyof typeof ICON_MAP
}

export const NAV_ITEMS: NavItem[] = [
  { path: '/', label: 'Overview', icon: 'LayoutDashboard' },
  { path: '/emails', label: 'Emails', icon: 'Mail' },
  { path: '/audiences', label: 'Audiences', icon: 'Users' },
  { path: '/campaigns', label: 'Campaigns', icon: 'Megaphone' },
  { path: '/domains', label: 'Domains', icon: 'Globe' },
  { path: '/analytics', label: 'Analytics', icon: 'BarChart3' },
  { path: '/templates', label: 'Templates', icon: 'FileCode' },
  { path: '/api-keys', label: 'API Keys', icon: 'Key' },
  { path: '/webhooks', label: 'Webhooks', icon: 'Webhook' },
  { path: '/wordpress', label: 'WordPress', icon: 'Plug' },
  { path: '/ips', label: 'Dedicated IPs', icon: 'Server' },
  { path: '/suppressions', label: 'Suppressions', icon: 'ShieldOff' },
  { path: '/notifications', label: 'Notifications', icon: 'Bell' },
  { path: '/billing', label: 'Billing', icon: 'CreditCard' },
  { path: '/settings', label: 'Settings', icon: 'Settings' },
]
